/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Column {
    SIMILARITY = 'similarity',
    ESTIMATED_OCCUPANCY = 'estimated_occupancy',
    EXPOSURE_PERCENT = 'exposure_percent',
    YEAR_BUILT = 'year_built',
    NUMBER_UNITS = 'number_units',
    NUMBER_STORIES = 'number_stories',
    NUMBER_LEASED = 'number_leased',
    CURRENTLY_AVAILABLE = 'currently_available',
    DAYS_ON_MARKET = 'days_on_market',
    MIN_SQFT = 'min_sqft',
    SQFT = 'sqft',
    MAX_SQFT = 'max_sqft',
    MIN_MARKET_RENT = 'min_market_rent',
    MARKET_RENT = 'market_rent',
    MAX_MARKET_RENT = 'max_market_rent',
    RENT_PSF = 'rent_psf',
    EFFECTIVE_RENT = 'effective_rent',
    EFFECTIVE_RENT_PSF = 'effective_rent_psf',
    CONCESSION_PERCENT = 'concession_percent',
    TREND = 'trend',
    LABEL = 'label',
    ADDRESS = 'address',
    AVG_RENT = 'avg_rent',
    ACTIONS = 'actions',
    NUMBER_LISTINGS = 'number_listings',
    RENEWAL_PERCENT = 'renewal_percent',
    TRADEOUT_PERCENT = 'tradeout_percent',
    NUMBER_APPS_TO_CANCELS = 'number_apps_to_cancels',
    CANCEL_PERCENT = 'cancel_percent',
    LEASED_DATE = 'leased_date',
    BED = 'bed',
    FLOORPLAN_NAME = 'floorplan_name',
}
